import React, {useState} from "react";
import PropTypes from "prop-types";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, TextField, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { LoadingButton } from "@mui/lab";

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  loading: PropTypes.bool,
  message: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  name: PropTypes.bool,
  note: PropTypes.bool,
  select: PropTypes.bool,
  selectOptions: PropTypes.array,
  selectLabel: PropTypes.string,
  textFieldLabel: PropTypes.string,
  detailMessage: PropTypes.string
}
export default function ConfirmDialog ({ open, title, loading, message, onCancel, onConfirm, confirmText = "Confirm", cancelText = "Cancel", name, note, select, selectOptions = [] , selectLabel = "Select Option", textFieldLabel, detailMessage}) {
  const [inputValue, setInputValue] = useState("");
  const [noteValue, setNoteValue] = useState("");
  const [selectValue, setSelectValue] = useState("");
  
  const isConfirmDisabled = (name && !inputValue.trim()) || (note && !noteValue.trim()) || (select && !selectValue);
  function handleClose() {
    onCancel();
    setInputValue('')
    setNoteValue('')
    setSelectValue('')
  }

  return (
    <Dialog data-testid='confirm-dialog' open={open} onClose={() => handleClose()} fullWidth sx={{ "& .MuiDialog-paper": { width: "25%", maxWidth: "none" } }}>
      <DialogTitle>
        <Typography variant="h6">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: '14px', fontWeight: 800 }}>{message || "Are you sure you want to proceed?"}</Typography>
        {detailMessage && (
          <Typography sx={{ fontSize: '13px', fontWeight: 500, mt: 1, wordBreak: 'break-word' }}>
            {detailMessage}
          </Typography>
        )}
        {name && (
          <TextField
            label={textFieldLabel}
            fullWidth
            variant="outlined"
            sx={{ mt: 2 }}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        )}
        {note && (
          <TextField
            label="Reason"
            fullWidth
            variant="outlined"
            multiline
            rows={2}
            sx={{ mt: 2 }}
            value={noteValue}
            onChange={(e) => setNoteValue(e.target.value)}
          />
        )}
        {select && (
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>{selectLabel}</InputLabel>
            <Select
              value={selectValue}
              label="Select Option"
              onChange={(e) => setSelectValue(e.target.value)}
            >
              {selectOptions?.map((option) => (
                <MenuItem key={option?.value} value={option?.value}>
                  {option?.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions sx={{ pb: 2, pr: 2 }}>
        <Button data-testid='cancel-text' onClick={() => handleClose()} variant="outlined" sx={{ fontSize: '12px' }}>
          {cancelText}
        </Button>
        <LoadingButton data-testid='confirm-text'
          loading={loading}
          onClick={() => {
            if (select) {
              onConfirm(selectValue);
            } else if (name) {
              onConfirm(inputValue);
            } else if (note) {
              onConfirm(noteValue);
            } else {
              onConfirm();
            }
          }}
          variant="contained"
          color="primary"
          sx={{ fontSize: '12px' }}
          disabled={isConfirmDisabled}
        >
          {confirmText}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
